// Approval expiry comes from the server; this display never extends authorization.
export function approvalSecondsRemaining(value, now = Date.now()) {
  if (typeof value !== 'string' || !value) return 0;
  const stamped = /(?:Z|[+-]\d{2}:\d{2})$/i.test(value) ? value : value + 'Z';
  const deadline = Date.parse(stamped);
  return Number.isFinite(deadline) && Number.isFinite(now)
    ? Math.max(0, Math.ceil((deadline - now) / 1000)) : 0;
}
